// Bandejas predefinidas — 1-click fill
// Cada preset mapea num → cantidad. Total se calcula en runtime.

export const PRESETS = [
  {
    id: 'mar',
    label: 'Sabor del Mar',
    desc: 'Anchoa, boquerón, matrimonio, pulpo, mejillón y langostino.',
    total: 24,
    qty: { '02': 4, '03': 4, '04': 4, '06': 4, '07': 4, '09': 4 },
  },
  {
    id: 'sin-pescado',
    label: 'Sin Pescado',
    desc: 'La Verde, queso y selección ibérica para los que no quieren pescado.',
    total: 12,
    qty: { '10': 6, '08': 3, '05': 3 },
  },
  {
    id: 'valientes',
    label: 'Para los Valientes',
    desc: 'Picante, ibérica y pulpo. Sabor intenso.',
    total: 18,
    qty: { '12': 8, '05': 5, '06': 5 },
  },
  {
    id: 'seleccion',
    label: 'La Selección Cabrero',
    desc: 'Dos de cada — un poco de todo lo que hacemos.',
    total: 24,
    qty: {
      '01': 2, '02': 2, '03': 2, '04': 2, '05': 2, '06': 2,
      '07': 2, '08': 2, '09': 2, '10': 2, '11': 2, '12': 2,
    },
  },
];
